import { useState } from "react";

export function CalendarIcon({ styles }) {
  const [hovered, setHovered] = useState(false);

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ cursor: "pointer", ...styles }}
      id="calendar-icon"
    >
      <path
        d="M10.0015 9.16057C12.632 9.16057 15.2624 9.16057 17.8929 9.16057C18.3248 9.16057 18.3248 9.1612 18.3248 9.60658C18.3248 11.6155 18.3266 13.625 18.3241 15.6339C18.3223 17.2905 17.2888 18.3312 15.6419 18.3318C11.8781 18.3337 8.11431 18.3343 4.35053 18.3318C2.71796 18.3305 1.67639 17.2905 1.67389 15.6601C1.67077 13.6206 1.67888 11.5805 1.66702 9.53974C1.66515 9.2424 1.74503 9.15245 2.04771 9.15433C4.69877 9.16557 7.35045 9.16057 10.0015 9.16057Z"
        fill={hovered ? "#88888aff" : "#A4A5B1"}
        style={{ transition: "all 0.3s ease-out" }}
      />
      <path
        d="M5.00573 4.16711C5.00573 3.60617 5.00386 3.09707 5.00636 2.58798C5.00885 2.04515 5.32838 1.68222 5.81266 1.66723C6.30692 1.65162 6.66264 2.01454 6.67388 2.56799C6.68449 3.0852 6.67637 3.60304 6.67637 4.14087C8.90556 4.14087 11.0942 4.14087 13.324 4.14087C13.324 3.69799 13.3215 3.27447 13.3252 2.85033C13.3265 2.68417 13.324 2.51552 13.3514 2.35311C13.4245 1.91959 13.7871 1.641 14.2183 1.66911C14.6458 1.69722 14.9803 2.02516 14.9909 2.4618C15.0046 3.01274 14.994 3.56369 14.994 4.16086C15.1781 4.16086 15.3416 4.17086 15.5032 4.15961C17.2007 4.03905 18.4501 5.29961 18.3272 7.00118C18.3159 7.15359 18.3259 7.30788 18.3259 7.47966C12.7636 7.47966 7.23741 7.47966 1.69753 7.47966C1.6114 6.5127 1.68504 5.61819 2.41084 4.88796C3.1279 4.16773 4.03093 4.11776 5.00573 4.16711Z"
        fill={hovered ? "#88888aff" : "#A4A5B1"}
        style={{ transition: "all 0.3s ease-out" }}
      />
    </svg>
  );
}
